import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from 'react-select';
import * as actions from '../redux/actions';
import CustomRadio from '../../../common/ui/CustomRadio';
import { getDescriptionForCheckbox, userUtilPaths } from '../../../common/utils/api_utils';

export class RouteConfig extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleMultiSelectChange = (name, selRoleOpts) => {
    const { route, actions, projectId, version } = this.props;
    if (!selRoleOpts) {
      route[name] = [];
      route.projectId = projectId;
      route.version = version;
      route.settingType = name;
      actions.enableDeveloperApis(route);
    } else {
      const oldOptions = route[name];
      const newValues = selRoleOpts.map((opt) => opt.value);
      let updatedValue = [...oldOptions, ...newValues];
      updatedValue = updatedValue.filter((val) => newValues.includes(val));
      updatedValue = [...new Set(updatedValue)];
      route[name] = updatedValue;
      route.projectId = projectId;
      route.version = version;
      route.settingType = name;
      actions.enableDeveloperApis(route);
    }
  };

  toggleCheckbox = (event) => {
    const { route, actions, projectId, version } = this.props;
    const { name, value, isChecked } = event.target;
    route[name] = !route[name];
    route.projectId = projectId;
    route.version = version;
    route.settingType = name;
    actions.enableDeveloperApis(route);
  };

  renderCheckbox = (label, name) => {
    const { route } = this.props;
    if (!route) {
      return '';
    }
    const description = getDescriptionForCheckbox(name, route[name]);
    return (
      <div className="form-check ml-5">
        <CustomRadio label={label} isRadio={false}>
          <input
            name={name}
            type="checkbox"
            className="form-check-input"
            checked={route[name]}
            onChange={this.toggleCheckbox}
          />
        </CustomRadio>
        {description && <p>{description}</p>}
      </div>
    );
  };

  renderRolesSelect = () => {
    const { userRoles, route } = this.props;
    if (!route['userAuthenticate']) {
      return '';
    }
    if (!userRoles || !userRoles.length) {
      return '';
    }
    const rolesOptions = userRoles.map((role) => ({ label: role.name, value: role.name }));
    const values = rolesOptions.filter((opt) => route.roles.includes(opt.value));
    return (
      <div className="row mt-3">
        <div className="col-md-2 pr-0 mt-2 ml-2">
          <b>Authorized Roles:</b>
        </div>
        <div className="col-md-8">
          <Select
            isMulti
            options={rolesOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={(selRoleOpts) => this.handleMultiSelectChange('roles', selRoleOpts)}
            value={values}
          />
        </div>
      </div>
    );
  };

  renderPermissionsSelect = () => {
    const { allPermissions, route } = this.props;

    if (!route['userAuthenticate']) {
      return '';
    }

    if (!allPermissions || !allPermissions.length) {
      return '';
    }

    const permissionOptions = allPermissions.map((permission) => ({
      label: permission.name,
      value: permission.name,
    }));
    const values = permissionOptions.filter((opt) => route.permissions.includes(opt.value));

    return (
      <div className="row mt-3">
        <div className="col-md-2 pr-0 mt-2 ml-2">
          <b>Authorized Permissions:</b>
        </div>
        <div className="col-md-8">
          <Select
            isMulti
            options={permissionOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={(selPermissionOpts) =>
              this.handleMultiSelectChange('permissions', selPermissionOpts)
            }
            value={values}
          />
        </div>
      </div>
    );
  };

  showDecryptionCheckbox = () => {
    const { enableEncryption, route } = this.props;
    if (!enableEncryption) {
      return '';
    }
    const { method } = route;
    if (method.startsWith('GET')) {
      return this.renderCheckbox('Decrypted Data', 'isEncrypted');
    }
  };

  isUtilRoute = (uniqueKey) => {
    let final = false;
    userUtilPaths.forEach((path) => {
      if (uniqueKey.endsWith(path.url)) final = true;
    });
    return final;
  };

  render() {
    const { route, userRoles, allPermissions } = this.props;
    const { method, url, urlDescription, description, enable } = route;
    if (!method) {
      return '';
    }

    return (
      <div className="my-2 pb-3">
        <h5 className="bg-light border-0 p-10 rounded">
          <strong style={{ marginRight: '6px' }}>{method.split('_')[0]}: </strong>
          <span className="m-2"> {url}</span>
        </h5>
        <div className="px-2">
          <strong style={{ color: 'grey', marginLeft: '5px' }}>{urlDescription}</strong>
          <div className="row">
            {this.renderCheckbox('Enable', 'enable')}
            <div className="form-check-inline">
              {enable ? (
                <>
                  {this.renderCheckbox('Authorization', 'auth')}
                  {route.uniqueKey && this.isUtilRoute(route.uniqueKey)
                    ? ''
                    : this.renderCheckbox('User Authentication', 'userAuthenticate')}
                  {this.showDecryptionCheckbox()}
                </>
              ) : (
                ''
              )}
            </div>
          </div>
          {this.renderRolesSelect()}
          {this.renderPermissionsSelect()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RouteConfig);
